import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "rep_prototype_token";
const PID_KEY = "rep_prototype_project_id";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const getProjectId = () => localStorage.getItem(PID_KEY);
export const setProjectId = (id) => localStorage.setItem(PID_KEY, id);
export const clearProjectId = () => localStorage.removeItem(PID_KEY);

const api = axios.create({ baseURL: `${BASE}/api` });

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers["x-prototype-token"] = t;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const detail = err.response?.data?.detail;
    if (err.response?.status === 401 && detail && detail.code === "AUTH") {
      clearToken();
      window.dispatchEvent(new Event("prototype-logout"));
    }
    return Promise.reject(err);
  },
);

// Turn any backend/Rendy error into a friendly Dutch string.
export function apiErrorMessage(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Er ging iets mis. Probeer het opnieuw.";
  if (typeof d === "string") return d;
  return d.message || "Er ging iets mis. Probeer het opnieuw.";
}

// Full technical detail for the owner-only debug panel (never contains secrets).
export function apiErrorTechnical(err) {
  const d = err?.response?.data?.detail;
  if (d && typeof d === "object") {
    return {
      status: err.response?.status,
      rendyStatus: d.rendyStatus,
      code: d.code,
      message: d.message,
      technical: d.technical,
    };
  }
  return { status: err?.response?.status, message: err?.message };
}

export const prototypeApi = {
  login: (password) => axios.post(`${BASE}/api/prototype/login`, { password }),
  health: () => api.get("/prototype/health"),
  config: () => api.get("/prototype/config"),
  presets: () => api.get("/rendy/presets"),
  listProjects: () => api.get("/prototype/projects"),
  saveProject: (payload) => api.post("/prototype/projects", payload),
  getProject: (id) => api.get(`/prototype/projects/${id}`),
  setNote: (id, note) => api.patch(`/prototype/projects/${id}/note`, { note }),
  usage: () => api.get("/prototype/usage"),
  uploadImage: (form, onUploadProgress) =>
    api.post("/rendy/images/upload", form, { onUploadProgress, timeout: 180000 }),
  createListing: (payload) => api.post("/rendy/listings", payload),
  listingStatus: (id) => api.get(`/rendy/listings/${id}/status`),
  getListing: (id) => api.get(`/rendy/listings/${id}`),
  exportListing: (id) => api.post(`/rendy/listings/${id}/export`),
  exportStatus: (jobId) => api.get(`/rendy/exports/${jobId}`),
};
